export default "__VITE_ASSET__C8cS7Qxb__"